// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"36":"9f228661","97":"78efdd51","349":"09caf7c7","784":"fd7ee868"}[chunkId] + ".js";
};